import { AxiosRequestConfig } from "axios";
import { httpService } from "./HttpServices";
import { ApiResponse } from "./UserService";

export interface OrganizationResponse {
  accessToken: string;
}

export class OrganizationService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = "/users";
  }

  async switchOrganizations(
    organizationId: string,
    config?: AxiosRequestConfig
  ): Promise<{ data: OrganizationResponse; message: string }> {
    try {
      const response = await httpService.post<
        ApiResponse<OrganizationResponse>
      >(
        `${this.baseUrl}/organizations/switch-organization`,
        { organizationId },
        config
      );

      return {
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "An unexpected error occurred while switching organizations.";
      throw new Error(errorMessage);
    }
  }

  async updateOrganizationName(
    newName: string,
    config?: AxiosRequestConfig
  ): Promise<{ data: {}; message: string }> {
    if (!newName) {
      throw new Error("Organization name is required.");
    }

    try {
      const response = await httpService.patch<ApiResponse<{}>>(
        `${this.baseUrl}/organizations/update-organization-name`,
        { newName },
        config
      );

      return {
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to update the organization's name.";
      throw new Error(errorMessage);
    }
  }
}

export const organizationService = new OrganizationService();
